import { lang } from '@umu/ukit-lang';
import { IKeyVal } from '../../../@aiReportSection/types';

export const columns: IKeyVal = {
    volume: lang('音量清晰'),
    speed: lang('语速适中'),
    smooth: lang('语言流畅'),
    sight: lang('眼神自信'),
    smile: lang('微笑亲和'),
    gesture: lang('手势呈现'),
};

const dimensionOrder: { [index: string]: number } = {
    volume: 1,
    speed: 2,
    smooth: 3,
    sight: 4,
    smile: 5,
    gesture: 6,
};

export const dimensionCompare = (a: string, b: string) => {
    if (!dimensionOrder[a] || !dimensionOrder[b]) {
        return -1;
    }
    return dimensionOrder[a] > dimensionOrder[b] ? 1 : -1;
};
